import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  background: ${({ theme }) => theme.colors.lighterBackground};
  border-radius: 10px;
  background: ${({ theme }) => theme.colors.lighterBackground};
  border-radius: 0.375em;
  padding: 16px 24px 24px 24px;
  margin: 12px 8px 24px 0px;

  header {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 12px;
    img {
      width: 28px;
      margin-right: 8px;
    }
    div {
      font-size: 18px;
      font-weight: bold;
    }
  }

  > div {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    gap: 12px;
    margin: 12px 0;
    position: relative;

    @media(max-width: 500px) {
      flex-direction: column;
      gap: 12px;
    }

    /* Primeira linha de filtros (atividade e parceiro) com z-index maior */
    &:first-of-type {
      z-index: 3;
    }

    /* Segunda linha de filtros (notas e duração) com z-index menor */
    &:last-of-type {
      z-index: 2;
    }

    /* Garantir que os dropdowns dos selects apareçam acima de tudo */
    .react-select-container-as-filter {
      position: relative;
      z-index: inherit;
    }
  }
`;
